import { atom, SetterOrUpdater, useRecoilState } from "recoil"
import { RECOIL_KEY } from "globalState/key"
import { PhotoWithIndex } from "type"

const displayedPhotoAtom = atom<PhotoWithIndex>({
  key: RECOIL_KEY.DISPLAYED_PHOTO,
  default: undefined
})

export const useDisplayedPhoto = (): [PhotoWithIndex, SetterOrUpdater<PhotoWithIndex>]=>{
  return useRecoilState(displayedPhotoAtom)
}